import React, { Component } from "react";
import ReactDOM from "react-dom";
import PropTypes from "prop-types";

export default class SVGInputField extends Component {
	constructor(props) {
		super(props);
		this.state = {
			stateClass: "",
			inputValue: ""
		};
	}

	componentDidMount() {
		this.setState({ stateClass: "initial" });
	}
	componentWillUnmount() {}

	handleChange = e => {
		this.props.onChange(e.target.name, e.target.value);
		// this.setState({ inputValue: e.target.value });
	};

	handleBlur = e => {
		if (e.target.value === "") {
			this.setState({ stateClass: "initial" });
		} else {
			this.setState({ stateClass: "validate" });
			let valid = this.validateField(e.target.value, this.props.type);
			setTimeout(
				function() {
					this.setState({ stateClass: valid });
				}.bind(this),
				500
			);
		}
	};

	validateField = (val, type) => {
		var regExpEmail = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
		var regExpText = /[a-zA-Z]+/;
		var regExpTel = /^(\+\d{1,2}\s)?\(?\d{3}\)?[\s.-]?\d{3}[\s.-]?\d{4}$/;
		var resp;
		switch (type) {
			case "email":
				regExpEmail.test(val) ? (resp = "success") : (resp = "error");
				break;
			case "text":
				regExpText.test(val) ? (resp = "success") : (resp = "error");
				break;
			case "tel":
				regExpTel.test(val) ? (resp = "success") : (resp = "error");
				break;
			default:
				resp = "error";
				// resp = "error";
				break;
		}
		return resp;
	};

	render() {
		let {
			datatext,
			placeholder,
			icon,
			name,
			inputValue,
			textarea,
			controlWidth = ""
		} = this.props;
		let { stateClass } = this.state;

		return (
			<div className={`form-field ${stateClass} ${controlWidth}`}>
				<svg
					className={`svgFormBg loader ${stateClass}`}
					xmlns="http://www.w3.org/2000/svg"
					width="100%"
					height="41">
					<g>
						<circle
							cx="20"
							cy="20"
							r="20"
							className="ls-circle"
							id="ls-circle"
							transform="rotate(90 20 20)"
						/>
						<line
							x1="20"
							y1="40"
							x2={`${controlWidth === "full" ? 750 : 350}`}
							y2="40"
							className="ls-line"
							id="ls-line"
						/>
						<circle
							cx={controlWidth === "full" ? 740 : 345}
							cy="0"
							r="20"
							className="rs-circle"
							id="rs-circle"
							transform={
								controlWidth === "full"
									? "rotate(90, 740, 20)"
									: "rotate(90, 345, 20)"
							}
						/>
						<path
							fill="none"
							stroke="#000000"
							strokeLinecap="round"
							className="rs-tick"
							strokeMiterlimit="10"
							d="M28.656,13.526L17.005,25.178l-4.886-4.886
l-9.73-9.78C5.769,4.253,12.388,0,20,0c11.045,0,20,8.954,20,19.999C40,31.046,31.045,40,20,40"
						/>
						<g className="rs-error-g">
							<path
								fill="none"
								strokeMiterlimit="10"
								d="M19.75,24.384V0H20c11.045,0,20,8.954,20,19.999
C40,31.046,31.045,40,20,40"
								className="rs-close"
							/>
							<path
								fill="none"
								strokeMiterlimit="10"
								d="M19.75,29.875c-0.268,0-0.5,0.224-0.5,0.5
c0,0.268,0.224,0.5,0.5,0.5c0.268,0,0.5-0.224,0.5-0.5C20.25,30.107,20.026,29.875,19.75,29.875z"
								className="rs-close-dot"
							/>
						</g>
					</g>
				</svg>
				<div className="input-wrap">
					{textarea ? (
						<textarea
							type="text"
							className="input-field"
							placeholder={placeholder}
							datatext={datatext}
							value={inputValue}
							name={name}
							rows="5"
							onChange={this.handleChange.bind(this)}
							onFocus={() => this.setState({ stateClass: "focus" })}
							onBlur={this.handleBlur}
						/>
					) : (
						<input
							type="text"
							className="input-field"
							placeholder={placeholder}
							datatext={datatext}
							value={inputValue}
							name={name}
							onChange={this.handleChange.bind(this)}
							onFocus={() => this.setState({ stateClass: "focus" })}
							onBlur={this.handleBlur}
						/>
					)}

					<span className="input-title">{placeholder}</span>
				</div>
				<div className="icon-wrap">
					<object
						data={`images/fa/${icon}`}
						type="image/svg+xml"
						className="text-icon"
					/>
				</div>
			</div>
		);
	}
}
